import React, { useState, useContext } from 'react';
import { Grid, makeStyles, TextField } from '@material-ui/core';
import _ from 'lodash';
import { Field } from 'formik';

import GrowingTable from 'app/components/GrowingTable';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { RadioButtonGroup, RadioButton } from 'app/components/FormElements';
import helpers from 'app/utils/helpers';
import { FormServiceContext } from 'app/utils/contexts';

import styles from './styles';
import NumberFormatCustom from 'app/components/NumberFormatCustom';
const useStyles = makeStyles(styles);

function AdditionalData(props) {
    const classes = useStyles();
    const { errors, values, touched, onChangeDate } = props;

    const { isInternalForm, canEdit } = useContext(FormServiceContext);
    const [vlCapital, setVlCapital] = useState(values.vlCapital);

    const [deletedContacts, setDeletedContacts] = useState(() => {
        if (values.contatosExcluidos) {
            return values.contatosExcluidos;
        }
        return [];
    });

    const [partners, setPartners] = useState(() => {
        if (values.socios) {
            return values.socios.map((contact) => {
                contact.showDeleteButton = true;
                return contact;
            });
        } else if (values.contatos) {
            const partnersTemp = values.contatos
                .filter((contact) => !!contact.peParticipacaoSocietaria && !contact.boExcluido)
                .map((contact) => {
                    contact.showDeleteButton = true;
                    return contact;
                });
            values.socios = partnersTemp;
            return partnersTemp;
        }
        return [];
    });

    const [tableData, setTableData] = useState({
        columns: [
            {
                title: 'Nome*',
                field: 'nmPessoa',
                align: 'center',
                editComponent: (props) => (
                    <TextField
                        {...props}
                        variant="outlined"
                        label="Nome*"
                        margin="dense"
                        disabled={!canEdit}
                        fullWidth
                        inputProps={{
                            maxLength: 180,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                ),
            },
            {
                title: 'Função*',
                field: 'deFuncao',
                align: 'center',
                editComponent: (props) => (
                    <TextField
                        {...props}
                        variant="outlined"
                        margin="dense"
                        label="Função*"
                        disabled={!canEdit}
                        fullWidth
                        inputProps={{
                            maxLength: 90,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                ),
            },
            {
                title: 'Participação*',
                field: 'peParticipacaoSocietaria',
                align: 'center',
                editComponent: (props) => (
                    <TextField
                        {...props}
                        variant="outlined"
                        type="number"
                        margin="dense"
                        label="Participação*"
                        disabled={!canEdit}
                        fullWidth
                        inputProps={{
                            min: 0,
                            max: 100,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                ),
            },
        ],
        data: partners,
    });

    const addContact = (contact) => {
        let temp = _.cloneDeep(contact);
        temp.data = temp.data.map((c) => {
            c.showDeleteButton = true;
            return c;
        });
        setTableData(temp);
        setPartners(temp.data);
        values.socios = temp.data;
    };

    const onChangeField = (e, index) => {
        const name = e.target.name;
        const value = e.target.value;
        const temp = [...partners];
        temp[index][name] = value;
        temp[index]['boPrincipalContato'] = false;
        temp[index].showDeleteButton = true;
        if (name === 'peParticipacaoSocietaria') {
            if (Number(temp[index][name]) > 100) {
                temp[index][name] = 100;
            }
        }
        if (!temp[index]['peParticipacaoSocietaria']) temp[index]['peParticipacaoSocietaria'] = '';
        setPartners(temp);
        values.socios = temp;
    };

    const handleChangeVlCapital = (event) => {
        setVlCapital(event.target.value);
        values.vlCapital = event.target.value;
    };

    const changeContact = (index) => {
        const temp = [...tableData.data];
        if (index === undefined) {
            temp.push({});
        } else {
            if (window.confirm('Deseja excluir este item?')) {
                if (temp[index].cdPessoaEmpresa) {
                    const t = [...deletedContacts];
                    const contact = { ...temp[index], boExcluido: true };
                    t.push(contact);
                    setDeletedContacts(t);
                    values.contatosExcluidos = t;
                }
                temp.splice(index, 1);
            }
        }
        addContact({ ...tableData, data: temp });
    };

    return (
        <>
            <Grid container spacing={3} className={classes.containerTitle}>
                <Grid item xs={12} sm={6}>
                    <h3 className={classes.title}>Fundação da empresa</h3>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <Field
                        name="dtFundacao"
                        label="Data da fundação*"
                        format="DD/MM/YYYY"
                        autoOk
                        clearable
                        clearLabel={'Limpar'}
                        emptyLabel={''}
                        value={helpers.formatarData(values.dtFundacao)}
                        invalidLabel="Data inválida"
                        invalidDateMessage="Data inválida"
                        maxDateMessage="Data inválida"
                        minDateMessage="Data inválida"
                        margin="dense"
                        disabled={!canEdit}
                        onChange={(v) => onChangeDate(values, 'dtFundacao', v)}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        inputVariant="filled"
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        error={!!errors.dtFundacao && touched.dtFundacao}
                        helperText={errors.dtFundacao && touched.dtFundacao ? errors.dtFundacao : ''}
                        as={KeyboardDatePicker}
                    />
                </Grid>
                <Grid item xs={12} sm={4}></Grid>
                {values.cdTipoEmpresa >= 12 && values.cdTipoEmpresa <= 17 && (
                    <Grid item xs={12} sm={4}>
                        <Field
                            name="nuEmbratur"
                            label="Número EMBRATUR"
                            margin="dense"
                            disabled={!canEdit}
                            variant="filled"
                            fullWidth
                            error={!!errors.nuEmbratur && touched.nuEmbratur}
                            helperText={errors.nuEmbratur && touched.nuEmbratur ? errors.nuEmbratur : ''}
                            as={TextField}
                            inputProps={{
                                maxLength: 45,
                            }}
                        />
                    </Grid>
                )}
            </Grid>
            <Grid container spacing={3} className={classes.containerTitle}>
                <Grid item xs={12} sm={6}>
                    <h3 className={classes.title}>Registro</h3>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <RadioButtonGroup
                        id="tpRegistro"
                        label="Tipo de Registro*"
                        value={values.tpRegistro}
                        error={errors.tpRegistro}
                        touched={touched.tpRegistro}
                        className={classes.radioGroup}>
                        <Field component={RadioButton} name="tpRegistro" id="C" label="Cartório" disabled={!canEdit} />
                        <Field
                            component={RadioButton}
                            name="tpRegistro"
                            id="J"
                            label="Junta Comercial"
                            disabled={!canEdit}
                        />
                    </RadioButtonGroup>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Field
                        name="deRegistro"
                        label="Registro Empresa*"
                        margin="dense"
                        disabled={!canEdit}
                        variant="filled"
                        fullWidth
                        error={!!errors.deRegistro && touched.deRegistro}
                        helperText={errors.deRegistro && touched.deRegistro ? errors.deRegistro : ''}
                        as={TextField}
                        inputProps={{
                            maxLength: 90,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Field
                        name="dtRegistro"
                        label="Data Registro da Empresa*"
                        format="DD/MM/YYYY"
                        autoOk
                        clearable
                        clearLabel={'Limpar'}
                        emptyLabel={''}
                        value={helpers.formatarData(values.dtRegistro)}
                        invalidLabel="Data inválida"
                        invalidDateMessage="Data inválida"
                        maxDateMessage="Data inválida"
                        minDateMessage="Data inválida"
                        margin="dense"
                        disabled={!canEdit}
                        onChange={(v) => onChangeDate(values, 'dtRegistro', v)}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        inputVariant="filled"
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        error={!!errors.dtRegistro && touched.dtRegistro}
                        helperText={errors.dtRegistro && touched.dtRegistro ? errors.dtRegistro : ''}
                        as={KeyboardDatePicker}
                    />
                </Grid>
                <Grid item xs={12} sm={8}>
                    <Field
                        name="nuArquivamento"
                        label="Número Último Arquivamento"
                        margin="dense"
                        disabled={!canEdit}
                        variant="filled"
                        fullWidth
                        error={!!errors.nuArquivamento && touched.nuArquivamento}
                        helperText={errors.nuArquivamento && touched.nuArquivamento ? errors.nuArquivamento : ''}
                        as={TextField}
                        inputProps={{
                            maxLength: 45,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Field
                        name="dtArquivamento"
                        label="Data Arquivamento"
                        format="DD/MM/YYYY"
                        autoOk
                        clearable
                        clearLabel={'Limpar'}
                        emptyLabel={''}
                        value={helpers.formatarData(values.dtArquivamento)}
                        invalidLabel="Data inválida"
                        invalidDateMessage="Data inválida"
                        maxDateMessage="Data inválida"
                        minDateMessage="Data inválida"
                        margin="dense"
                        disabled={!canEdit}
                        onChange={(v) => onChangeDate(values, 'dtArquivamento', v)}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        inputVariant="filled"
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        error={!!errors.dtArquivamento && touched.dtArquivamento}
                        helperText={errors.dtArquivamento && touched.dtArquivamento ? errors.dtArquivamento : ''}
                        as={KeyboardDatePicker}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <RadioButtonGroup
                        id="tpControleAcionario"
                        label="Controle Acionário"
                        value={values.tpControleAcionario}
                        error={errors.tpControleAcionario}
                        touched={touched.tpControleAcionario}>
                        <Field
                            component={RadioButton}
                            name="tpControleAcionario"
                            id="N"
                            label="Nacional"
                            disabled={!canEdit}
                        />
                        <Field
                            component={RadioButton}
                            name="tpControleAcionario"
                            id="P"
                            label="Privado"
                            disabled={!canEdit}
                        />
                        <Field
                            component={RadioButton}
                            name="tpControleAcionario"
                            id="E"
                            label="Estrangeiro"
                            disabled={!canEdit}
                        />
                        <Field
                            component={RadioButton}
                            name="tpControleAcionario"
                            id="S"
                            label="Estatal (Público)"
                            disabled={!canEdit}
                        />
                    </RadioButtonGroup>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Field
                        name="vlCapital"
                        error={!!errors.vlCapital && touched.vlCapital}
                        helperText={errors.vlCapital && touched.vlCapital ? errors.vlCapital : ''}>
                        {({ field, form: { errors, values } }) => (
                            <TextField
                                label="Capital Atual (Moeda Corrente)*"
                                value={vlCapital}
                                name="vlCapital"
                                margin="dense"
                                disabled={!canEdit}
                                onChange={handleChangeVlCapital}
                                variant="filled"
                                fullWidth
                                error={!!errors.vlCapital && touched.vlCapital}
                                helperText={errors.vlCapital && touched.vlCapital ? errors.vlCapital : ''}
                                InputProps={{
                                    inputComponent: NumberFormatCustom,
                                }}
                                inputProps={{
                                    maxLength: 18,
                                    form: {
                                        autoComplete: 'off',
                                    },
                                }}
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>
            <Grid container spacing={3} className={classes.containerTitle}>
                <GrowingTable
                    title="Sócios ou Acionistas - Pessoas Físicas ou Jurídicas"
                    tabledata={tableData}
                    addtabledata={addContact}
                    handlechange={onChangeField}
                    customAddElement={changeContact}
                    canEdit={canEdit}
                    isInternalForm={isInternalForm}
                />
            </Grid>
        </>
    );
}

export default AdditionalData;
